import { connect } from 'react-redux';

import type { Dispatch } from 'redux';

import { AlertsGroup, type AlertsGroupProps } from '../../components';
import { removeAlertAction, selectAlertsData } from '../../store';
import type { AlertsState } from '../../store/alertsStore';

type StateProps = Pick<AlertsGroupProps, 'alertsData'>;

type DispatchProps = Pick<AlertsGroupProps, 'onCloseAlert'>;

const mapStateToProps = (state: AlertsState): StateProps => ({
  alertsData: selectAlertsData(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onCloseAlert: (id: string) => {
    dispatch(removeAlertAction(id));
  },
});

export const AlertsContainer = connect<
  StateProps,
  DispatchProps,
  {},
  AlertsState
>(
  mapStateToProps,
  mapDispatchToProps
)(AlertsGroup);
